import styleInject from '../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".noborder-library---QtY9 {\n  border-bottom: 0;\n}\n\n.min-content-library--ROOpN {\n  min-height: min-content;\n}\n\n.active-library--6nFWk {\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.error-library--u9Mj- {\n  color: #ed002f;\n}";
var styles = {"noborder":"noborder-library---QtY9","active":"active-library--6nFWk","error":"error-library--u9Mj-"};
styleInject(css_248z);

export { styles as default };
